<form [formGroup]="agentForm">
    <div class="form-wrapper input-wrapper">
        <p>Provide the URL in which AI Assist will make a POST request.</p>
        <mat-form-field class="form-field">
            <mat-label>API Url</mat-label>
            <input matInput formControlName="apiUrl">

            @if (agentForm.get('apiUrl')!.hasError('invalidUrlOrDefault')) {
                <mat-error>
                    Enter a valid URL or 'https://'.
                </mat-error>
            }
        </mat-form-field>

        <p>By default all requests are sent via POST. To use GET, check this box. All information will be appended to the URL as query parameters.</p>
        <div class="check-box"><mat-checkbox formControlName="usesGet">Use GET</mat-checkbox></div>

        <p>Provide any headers to send with the request. Use JSON format here, such as</p>
        <pre>{{ '{' }} "Content-Type": "application/json" {{ '}' }}</pre>
        <mat-form-field class="form-field">
            <mat-label>Headers (Optional)</mat-label>
            <textarea matInput formControlName="apiHeaders" cdkTextareaAutosize cdkAutosizeMinRows="3"></textarea>

            @if (agentForm.get('apiHeaders')!.hasError('invalidJson')) {
                <mat-error>
                    Invalid JSON format.
                </mat-error>
            }
        </mat-form-field>

        @if (agentForm.get('usesGet')!.value === false) {
            <p>Provide any static JSON to send with the request such as</p>
            <pre>{{ '{' }} "myProperty": "myValue" {{ '}' }}</pre>
            <mat-form-field class="form-field">
                <mat-label>Payload (Optional)</mat-label>
                <textarea matInput formControlName="apiPayload" cdkTextareaAutosize cdkAutosizeMinRows="3"></textarea>

                @if (agentForm.get('apiPayload')!.hasError('invalidJson')) {
                    <mat-error>
                        Invalid JSON format.
                    </mat-error>
                }
            </mat-form-field>
        }


        <p>Below are optional properties sent in the payload and headers to your API endpoint. <strong>Please only include these if you explicitly need them.</strong></p>
        <div class="check-box">
            <mat-checkbox formControlName="sendUserInfo">Include User Name and Email</mat-checkbox>
            <mat-hint class="hint">Headers: x-aia-user-email and x-aia-user-name Body: xaia.userEmail and xaia.userName</mat-hint>
        </div>
        <div class="check-box">
            <mat-checkbox formControlName="sendSessionId">Include Session ID</mat-checkbox>
            <mat-hint class="hint">Header: x-aia-session-id Body: xaia.sessionId</mat-hint>
        </div>
        <div class="check-box">
            <mat-checkbox formControlName="sendMessageId">Include Message ID</mat-checkbox>
            <mat-hint class="hint">Header: x-aia-message-id Body: xaia.messageId</mat-hint>
        </div>
        <div class="check-box">
            <mat-checkbox formControlName="sendUserPrompt">Include User's Prompt</mat-checkbox>
            <mat-hint class="hint">Body: xaia.userPrompt</mat-hint>
        </div>

        <p>If the request payload needs to be manipulated before sending to the API, write a JavaScript function here to do so. The payload is a merged JSON object of the function parameters and the additional API payload values you included above, if any. It must be named "processRequest" and receives a string as the request payload. <strong>WARNING:</strong> if this function fails, an error is sent to the user. Here is an example:</p>
        <pre>function processRequest(body) {{ '{' }}
let data = JSON.parse(body);
data.calculatedParameter = data.criteria + '*';
return data;
{{ '}' }}</pre>
        <mat-form-field class="form-field">
            <mat-label>Request manipulation code</mat-label>
            <textarea matInput formControlName="requestManipulationCode" cdkTextareaAutosize cdkAutosizeMinRows="3"></textarea>
        </mat-form-field>

        <p>If the response needs to be manipulated before sending to the AI, write a JavaScript function here to do so. It must be named "processResponse" and receives a string as the response contents. WARNING: if this function fails, an error is sent to the user. Here is an example:</p>
        <pre>function processResponse(body) {{ '{' }}
let data = JSON.parse(body);
return {{ '{' }}
    "answer": data.specificValue
{{ '}' }};
{{ '}' }}</pre>
        <mat-form-field class="form-field">
            <mat-label>Response manipulation code</mat-label>
            <textarea matInput formControlName="responseManipulationCode" cdkTextareaAutosize cdkAutosizeMinRows="3"></textarea>
        </mat-form-field>
    </div>
</form>
